import { render, staticRenderFns } from "./TsNftSellPanel.vue?vue&type=template&id=83bd940a&scoped=true&"
import script from "./TsNftSellPanel.vue?vue&type=script&lang=js&"
export * from "./TsNftSellPanel.vue?vue&type=script&lang=js&"
import style0 from "./TsNftSellPanel.vue?vue&type=style&index=0&id=83bd940a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83bd940a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VCol,VContainer,VDivider,VRow})
